import type { FC } from 'react';
import classnames from 'classnames';

import Checkbox from 'app/components/Checkbox';
import TierIndicator from 'app/components/TierIndicator';
import type { EventTreeTournamentValue, EventTreeChangeAction } from 'app/pages/EventsPage/types';

import style from './style.scss';

interface Props {
  value: EventTreeTournamentValue;
  dispatchChange: (action: EventTreeChangeAction) => void;
}

const EventTreeTournament: FC<Props> = ({ value, dispatchChange }) => {
  const handleChange = () => {
    dispatchChange({ type: 'EVENT_TREE_TOGGLE_TOURNAMENT', payload: value.id });
  };

  return (
    <label className={style.line}>
      <Checkbox
        className={style.checkbox}
        size="small"
        status={value.selected ? 'checked' : 'unchecked'}
        onChange={handleChange}
      />
      {value.tier && <TierIndicator className={style.tier} tier={value.tier} />}
      <span
        className={classnames(style.tournamentName, {
          [style.tournamentName_withoutTier]: !value.tier
        })}
        title={value.label}
      >
        {value.label}
      </span>
    </label>
  );
};

EventTreeTournament.displayName = 'EventTreeTournament';

export default EventTreeTournament;
